<template> 	
    <product-page /> 
</template>
<script>
    import { Component, Vue } from "vue-property-decorator";
    import ProductPage from '@/components/product/index.vue';

	@Component({
        components: {
            ProductPage
        }
    })
	export default class Product extends Vue {}
</script>